import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Pipe({
  name: "highlightText",
})
export class HighlightTextPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string, searchTerm: string | null | undefined): SafeHtml {
    if (!searchTerm || !text) {
      return text;
    }

    const trimmedSearchTerm = searchTerm.trim();
    if (trimmedSearchTerm.length === 0) {
      return text;
    }

    // Normalize function to remove diacritics
    const normalize = (str: string): string => {
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    };

    // Normalize the search term
    const normalizedSearchTerm = normalize(trimmedSearchTerm);

    // Scan through the entire text looking for matches
    let highlightedText = "";
    let lastIndex = 0;

    for (let i = 0; i <= text.length - trimmedSearchTerm.length; i++) {
      // Extract substring of same length as search term
      const substring = text.substring(i, i + trimmedSearchTerm.length);
      const normalizedSubstring = normalize(substring);

      // Check if normalized substring matches normalized search term
      if (normalizedSubstring === normalizedSearchTerm) {
        // Add text before the match
        highlightedText += text.substring(lastIndex, i);
        // Add the highlighted match (with original diacritics)
        highlightedText += `<mark class="highlight-match">${substring}</mark>`;
        // Move past the match
        lastIndex = i + trimmedSearchTerm.length;
        i = lastIndex - 1; // Skip past the match
      }
    }

    // Add remaining text after last match
    highlightedText += text.substring(lastIndex);

    return this.sanitizer.sanitize(1, highlightedText) || text;
  }
}

